import {DialogActions, DialogContent} from '@mui/material';
import {bool, func} from 'prop-types';

import Button from '../../form/buttons/Button/Button';
import BaseModal from '../../modal/BaseModal';

const UpdateSecretConfirmationModal = ({isOpen, onClose, onSubmit}) => {
  return (
    <BaseModal title="Confirmer la modification du secret" maxWidth="sm" onClose={onClose} open={isOpen}>
      <DialogContent sx={{py: 3}}>Confirmez vous le remplacement du secret ? Cette opération est irréversible</DialogContent>
      <DialogActions sx={{justifyContent: 'center', mb: 2}}>
        <Button variant="outlined" color="error" onClick={onClose}>
          Annuler
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="error"
          onClick={() => {
            onSubmit();
            onClose();
          }}
        >
          Confirmer
        </Button>
      </DialogActions>
    </BaseModal>
  );
};

UpdateSecretConfirmationModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  onSubmit: func.isRequired
};

export default UpdateSecretConfirmationModal;
